/** --------------------------------------------------------------------------------------------------------------------
 * responsive view Row, try to be like Bootstrap
 *
 */

import React from "react";

import './index.css';

type Props = {
  children: React.ReactNode;

  id       ?: string             ;
  style    ?: React.CSSProperties;
  className?: string             ;
};

const Row = (props: Props) => {

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id={props.id} className={`responsive-view-row ${props?.className || ''}`} style={props.style}>
      {props.children}
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Row;
